import React, { useState } from 'react';
import {
    AddContainer, Component4, Texts, InputTextComponent,
    PrescriptionViewBox, PresText, PresTitle, EditButton, SaveButton, Component6, LabelWithTooltip
} from './Styles';
import { Formik, Form } from 'formik';
import {
    Box, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import theme from 'src/config/theme';
import useResponsive from 'src/components/hooks/useResponsive';

const CmsPagesStep = ({ data, innerRef, setClinicProfileData }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '20px';
    const Height = isMobile || isTablet ? '18px' : '20px';

    const [selectedPage, setSelectedPage] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [localPages, setLocalPages] = useState(data || []);

    const initialValues = {
        pageType: selectedPage?.pageType || '',
        title: selectedPage?.title || '',
        description: selectedPage?.description || '',
    };

    const handleEdit = (page) => {
        setSelectedPage(page);
        setOpenDialog(true);
    };

    const handleDelete = (pageToDelete) => {
        const updatedPages = localPages.filter(
            (page) =>
                !(
                    page.title === pageToDelete.title &&
                    page.pageType === pageToDelete.pageType
                )
        );
        setLocalPages(updatedPages);
        setClinicProfileData(prev => ({ ...prev, cmsPage: updatedPages }));
    };

    const handleAdd = () => {
        setSelectedPage(null);
        setOpenDialog(true);
    };

    const handleSubmit = (values, { resetForm }) => {
        if (!values.pageType.trim() || !values.title.trim()) return;

        setLocalPages(prev => {
            const isEditing = !!selectedPage;
            let updated;

            if (isEditing) {
                updated = prev.map(page =>
                    page.pageType === selectedPage.pageType &&
                        page.title === selectedPage.title
                        ? values
                        : page
                );
            } else {
                const duplicate = prev.find(
                    page =>
                        page.pageType.trim().toLowerCase() === values.pageType.trim().toLowerCase() &&
                        page.title.trim().toLowerCase() === values.title.trim().toLowerCase()
                );
                if (duplicate) return prev;

                updated = [...prev, values];
            }

            setClinicProfileData(prev => ({ ...prev, cmsPage: updated }));

            return updated;

        });

        setSelectedPage(null);
        setOpenDialog(false);
        resetForm();


    };

    return (
        <>
            <AddContainer>
                {localPages.map((page, index) => (
                    <PrescriptionViewBox key={index}>
                        <Box>
                            <PresTitle>{page.pageType}</PresTitle>
                            <PresText>{page.title}</PresText>
                            <PresText>{page.description}</PresText>
                        </Box>
                        <Box sx={{ display: 'flex', gap: '8px' }}>
                            <EditButton onClick={() => handleEdit(page)}>
                                <Edit width={Width} />
                            </EditButton>
                            <EditButton onClick={() => handleDelete(page)}>
                                <Close width={Width} />
                            </EditButton>
                        </Box>
                    </PrescriptionViewBox>
                ))}

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <SaveButton
                        variant="outlined"
                        startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}
                        onClick={handleAdd}
                    >
                        Add
                    </SaveButton>
                </Box>
            </AddContainer>

            <Dialog
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                    setSelectedPage(null);
                }}
                maxWidth="md"
            >
                <DialogTitle>{selectedPage ? 'Edit CMS Page' : 'Add CMS Page'}</DialogTitle>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={innerRef}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <DialogContent>
                                <AddContainer>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip label="Page Type" tooltip="Type of page (e.g., About Us, Contact, FAQ)" />
                                        </Texts>
                                        <InputTextComponent
                                            name="pageType"
                                            placeholder="Enter Page Type"
                                            variant="outlined"
                                            value={values.pageType}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip label="Title" tooltip="Page title" />
                                        </Texts>
                                        <InputTextComponent
                                            name="title"
                                            placeholder="Enter Title"
                                            variant="outlined"
                                            value={values.title}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip label="Description" tooltip="Page content or description" />
                                        </Texts>
                                        <InputTextComponent
                                            name="description"
                                            placeholder="Enter Description"
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            value={values.description}
                                            onChange={handleChange}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '120px',
                                                    alignItems: 'flex-start',
                                                },
                                            }}
                                        />
                                    </Component4>
                                </AddContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                                <Button type="submit" variant="contained">
                                    {selectedPage ? 'Update' : 'Save'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default CmsPagesStep;
